export const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";

export const fetchDataRequest = () => ({
  type: FETCH_DATA_REQUEST,
});

export const fetchDataSuccess = (data, dataType) => ({
  type: FETCH_DATA_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchDataFailure = (error) => ({
  type: FETCH_DATA_FAILURE,
  payload: error,
});

const loadingReducer = (state = false, action) => {
  switch (action.type) {
    case FETCH_DATA_REQUEST:
      return true;
    case FETCH_DATA_SUCCESS:
    case FETCH_DATA_FAILURE:
      return false;
    default:
      return state;
  }
};

export default loadingReducer;
